var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.93 6.202c.3-.15.38-.54.15-.78-.89-.98-1.79-1.8-2.51-2.42a.495.495 0 0 0-.82.38v3.58c0 .37.39.61.72.45l2.46-1.21zM12.75 21.388c0 .3.27.55.57.5a8.124 8.124 0 0 0 6.09-4.74c.19-.42-.27-.84-.69-.64l-5.69 2.79c-.17.08-.28.25-.28.44v1.65zM10.43 2.972c-2.36 1.98-6.55 6.15-6.53 10.93 0 4.02 2.94 7.35 6.78 7.99.3.05.57-.2.57-.5V3.362a.5.5 0 0 0-.82-.39zM18.73 10.251c.27-.12.4-.43.27-.69-.37-.73-.8-1.44-1.27-2.1-.14-.2-.4-.26-.62-.16l-4.09 1.99a.5.5 0 0 0-.28.45v2.27c.01.35.37.6.7.46l5.29-2.22zM20.09 13.91c0-.64-.08-1.27-.22-1.89-.07-.3-.4-.46-.68-.34l-6.14 2.62c-.18.08-.3.26-.3.46v2.2c0 .37.39.61.72.45l5.9-2.87.46-.23c.16-.08.26-.23.26-.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBlur);
export default __webpack_public_path__ + "static/media/vuesax-bold-blur.353dfa3f5a682c5b6e2e7cd1fce728a9.svg";
export { ForwardRef as ReactComponent };